import { useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { Link } from "react-router-dom";

export default function MagneticButton({
  children,
  className = "",
  variant = "primary",
  onClick,
  href,
  type = "button",
  testId,
  ...rest
}) {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const sx = useSpring(x, { stiffness: 220, damping: 14 });
  const sy = useSpring(y, { stiffness: 220, damping: 14 });

  const handleMove = (e) => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    const dx = e.clientX - (r.left + r.width / 2);
    const dy = e.clientY - (r.top + r.height / 2);
    x.set(dx * 0.25);
    y.set(dy * 0.4);
  };
  const handleLeave = () => {
    x.set(0);
    y.set(0);
  };

  const cls = `magnetic-btn ${variant === "ghost" ? "ghost" : ""} ${className}`;
  const Inner = (
    <motion.span
      ref={ref}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
      style={{ x: sx, y: sy }}
      className={cls}
      data-testid={testId}
      data-cursor="hover"
    >
      {children}
    </motion.span>
  );

  if (href) {
    const isExternal = /^https?:|^mailto:|^tel:|^#/.test(href);
    if (isExternal) {
      return (
        <a href={href} aria-label={typeof children === "string" ? children : "button"}>
          {Inner}
        </a>
      );
    }
    return (
      <Link to={href} aria-label={typeof children === "string" ? children : "button"}>
        {Inner}
      </Link>
    );
  }
  return (
    <button type={type} onClick={onClick} {...rest} className="bg-transparent border-0 p-0">
      {Inner}
    </button>
  );
}
